import { usePaginatedApi } from "../../../swr/useApi";
import { documentsService } from "../../api_client";
import type { UserDocumentsDto, DocumentsQueryDto } from "../../../api";

export function useDocumentsGroupedByUser(query?: DocumentsQueryDto) {
    return usePaginatedApi<UserDocumentsDto, DocumentsQueryDto>({
        key: "documents-grouped-by-user",
        serviceMethod: async (queryParams) => {
            return await documentsService.getDocumentsGroupedByUser(queryParams);
        },
        query: query,
    });
}

